import { 
    Headline1, 
    Headline2, 
    Headline3, 
    Headline4, 
    Headline5, 
    Headline6, 
    Paragraph, 
    Small 
} from '@cdm/quickenloans-library/lib';

export const Tags = [
    { tag: 'h1', Component: Headline1 },
    { tag: 'h2', Component: Headline2 },
    { tag: 'h3', Component: Headline3 },
    { tag: 'h4', Component: Headline4 },
    { tag: 'h5', Component: Headline5 },
    { tag: 'h6', Component: Headline6 },
    { tag: 'p', Component: Paragraph },
    { tag: 'small', Component: Small },
];
